// extracted by css-extract-rspack-plugin
export default {"subItems":"subItems-7P17ep","active":"active-IXPKVK"};